/**
 * TypingIndicator Component
 * Animated dots displayed while AI is processing/streaming
 */

import React from 'react';

function TypingIndicator() {
  return (
    <div className="chatbot-message assistant">
      <div className="chatbot-typing">
        <div className="chatbot-typing-dot"></div>
        <div className="chatbot-typing-dot"></div>
        <div className="chatbot-typing-dot"></div>
      </div>
    </div>
  );
}

export default TypingIndicator;
